export const SALESFORCE_CANCELLATION_POLICY_LABELS = [
  '7 day change of mind guarantee',
  'Flexible cancellation 21 days before check-in',
  'Flexible cancellation 45 days before check-in',
  'Flexible cancellation 10 days before check-in',
  'Hidden Cancellation Policy',
  'Flexible charter cancellation 21 days before check-in',
];

export function mapSFCancellationPolicyToAdmin(sfCancellationPolicy?: string): string | undefined {
  switch (sfCancellationPolicy) {
    case 'Flexible cancellation 21 days before check-in':
      return 'partner-policy-prior-to-check-in-twenty-one-days';
    case 'Flexible cancellation 45 days before check-in':
      return 'flexible-cancellation-forty-five-days';
    case 'Flexible cancellation 10 days before check-in':
      return 'flexible-cancellation-ten-days';
    case '7 day change of mind guarantee':
      return 'post-purchase-seven-days';
    case 'Hidden Cancellation Policy':
      return 'hidden-cancellation-policy';
    case 'Flexible charter cancellation 21 days before check-in':
      return 'flexible-cancellation-charter-twenty-one-days';
    default:
      return undefined;
  }
}

// Flash offers only support the Salesforce-mapped cancellation policy set.
export const FLASH_CANCELLATION_POLICY_VALUES = SALESFORCE_CANCELLATION_POLICY_LABELS.map((label) =>
  mapSFCancellationPolicyToAdmin(label),
).filter((value): value is string => !!value);
